import React,{useContext,useEffect,useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { AppContext } from "../../../Context/AppContext";
import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider,KeyboardDatePicker} from '@material-ui/pickers';
import axios from 'axios'
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';


const drawerWidth = 300;

const materialTheme = createTheme(({
    // set default for now
  }));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
  fullWidth: {
    width: "100%"
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});



function ReturnInformationReview(props) {
    const classes = useStyles();
    const { companyId } = useContext(AppContext);
    const [isSavingTransaction,setIsSavingTransaction] = useState(false)
    const [isSavingTransactionSuccess,setIsSavingTransactionSuccess] = useState(false)
    const [messageDialogMessage,setMessageDialogMessage] = useState("")
    const [showMessageDialog,setShowMessageDialog] = useState(false)


    const finalizedBtnClick = (event)=>{
       //props.closeAllDialog()
       const temporaryInventoryString = localStorage.getItem(companyId + "_temporary_inventory_count");
       if (temporaryInventoryString == null) {
            alert("No data to save.")
         return;
       }

       const temporaryInventoryJSON = JSON.parse(temporaryInventoryString)
       const products = [];

       temporaryInventoryJSON.forEach(product => {
           const productObject = {
               product_code:product.code,
               quantity_in_smallest_uom : computeTotalInventoryPerProduct(product.InputtedInventories),
               inputted_inventories : product.InputtedInventories
           };
           products.push(productObject)
       });

       saveAudit(products)

    }
    function computeTotalInventoryPerProduct(inputtedInventories){

        const totalInventoryInSmallestUom = Number(inputtedInventories.reduce((partialSum,inputtedInventory)=> 
        {
          const inventoryInSmallestUom = parseFloat(inputtedInventory.quantity) * inputtedInventory.conversion_to_smallest_uom
          return partialSum + (isNaN(inventoryInSmallestUom) ? 0 : inventoryInSmallestUom)

        },0.00 ))
        return totalInventoryInSmallestUom

    }
    function totalProductCountWithInventoryInputted(){
        const temporaryInventoryString = localStorage.getItem(companyId + "_temporary_inventory_count");
        if (temporaryInventoryString == null) {
        
          return 0;
        }
    
        const temporaryInventoryJSON = JSON.parse(temporaryInventoryString);
        return temporaryInventoryJSON.length
    
    }

    function saveAudit(auditedProducts){
  
      setIsSavingTransaction(true)    
        const formData = new FormData()
        formData.append("Items",JSON.stringify(auditedProducts))

        const options = {
            method: 'POST',
            url: '/TransactiLiteStockAudit/saveAudit.json',
            data:formData
          }
           axios(options)
             .then(res => {

              const isSuccess = res.data.response.is_success
              if(!isSuccess){
                 setIsSavingTransactionSuccess(false)
                 setIsSavingTransaction(false)
                 setMessageDialogMessage(res.data.response.message)
                 setShowMessageDialog(true)
    
                return;
              }
              
               localStorage.removeItem(companyId+"_temporary_inventory_count")
    
               setIsSavingTransactionSuccess(true)
               setIsSavingTransaction(false)
               setMessageDialogMessage("Transaction save successfully.")
               setShowMessageDialog(true)


              
             }).catch(error => {
              setIsSavingTransaction(false)
              
                setIsSavingTransactionSuccess(false)
                setIsSavingTransaction(false)
                setMessageDialogMessage("Failed to save invoice. Please try again.")
                setShowMessageDialog(true)
      
             })
    }

    function progressDialog(){
      return (
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            <Dialog
            fullWidth={true}
            maxWidth={'lg'}
            open={isSavingTransaction}
            onClose={()=>{}}
          >
          
            <DialogContent>
              <DialogContentText>
                Saving inventory... Please wait...
              </DialogContentText>
              <LinearProgress color="secondary" />
            </DialogContent>
          </Dialog>
        </ThemeProvider>
        </StyledEngineProvider>
      );
  }
  function messageDialog(){
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          <Dialog
          fullWidth={'sm'}
          maxWidth={'sm'}
          open={showMessageDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{

                setShowMessageDialog(false)
                if(isSavingTransactionSuccess == true){
                props.closeAllDialog()
                }
                
                
                }} 
              color="primary" autoFocus>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
      </StyledEngineProvider>
    );
  }
    return (
      <div>
         <Dialog fullScreen open={props.openReturnInformationReview} onClose={()=>{props.setOpenReturnInformationReview(false)}} TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
              <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={()=>{props.setOpenReturnInformationReview(false)}}
                    aria-label="close"
                    size="large">
                  <CloseIcon />
                  </IconButton>
                  <Typography variant="subtitle1" className={classes.title}>
                      Inventory Information
                  </Typography>
              </Toolbar>
          </AppBar>
          <div className={classes.appBarSpacer}></div>
          <div style={{padding:'.5rem'}}>
          <Grid container spacing={1}>
          
              
              <Grid item xs={12} >Number of lines : <span style={{fontSize:'1rem'}}>{totalProductCountWithInventoryInputted()}</span> </Grid>
              
              <Grid item container >
              <Button variant="contained" color="primary" style={{width:"100%"}} onClick={finalizedBtnClick}>
                  Finalize Inventory
              </Button>
              </Grid>
          </Grid>
          </div>
      </Dialog>
         {progressDialog()}
         {messageDialog()}
         
      </div>
    );
}

export default ReturnInformationReview